import React from "react";

function TermsAndConditions() {
  return (
    <main>
      {/* Breadcrumb Section */}
      <section className="page_breadcrumb" data-aos="fade-up">
        <div className="container">
          <div className="breadcrumb_content centred">
            <h1 className="breadcrumb_title">Terms And Conditions</h1>
            <ul className="breadcrumb_menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li>/</li>
              <li>Terms And Conditions</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Terms Section */}
      <section
        className="about_section_three"
        data-aos="fade-up"
        data-aos-duration="600"
      >
        <div className="container">
          <div className="section_title">
            <h2>Legal & Compliance Disclaimer</h2>
            <h5>(India - SEBI Aligned)</h5>
          </div>

          <div className="table_content">
            <ul className="feature_list text-left">
              <li className="Coverage-list">
                <p>
                  Eco Mantra Capital is a technology and support service
                  provider offering algorithmic trading tools and related
                  services. We do not provide any guaranteed returns or profit
                  assurances.
                </p>
              </li>
              {[
                "We are not a SEBI-registered Portfolio Manager or Investment Advisor (unless registered separately).",
                "All investment and trading decisions are executed at the sole discretion and risk of the client.",
                "Market investments are subject to risks including potential loss of capital.",
                "Past performance of any strategy or software does not guarantee future results.",
                "Clients are advised to consult their financial advisor before making investment decisions.",
                "In joint venture or partnership models, profit/loss sharing is strictly governed by mutually agreed contractual terms.",
                "All investments are subject to market risk.",
                "Eco Mantra Capital works on a joint venture basis as per contract.",
              ].map((item, index) => (
                <li className="Coverage-list" key={index}>
                  <i className="fa-solid fa-check"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
}

export default TermsAndConditions;
